// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__G4Nu5","col":"Table_col__2DRS4","fulfillmentStatus":"Table_fulfillmentStatus__2AHG8","emailCol":"Table_emailCol__JfYOm"};